import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Conectividadvpn/actualizarConectividadVPN`, method: 'POST', body: values, token: token})
}